import { Global, css } from '@emotion/react';

// Estilos globais mínimos — o resto vem do tema MUI (src/theme) e do CssBaseline.
const GlobalStyle = () => (
  <Global
    styles={css`
      html,
      body,
      #root {
        height: 100%;
      }

      body {
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
      }

      /* Overlays de terceiros (ex.: dev overlay) não podem capturar cliques. */
      body > iframe {
        pointer-events: none;
      }

      /* Esconde o "Secured by Clerk" do rodapé do SignIn/SignUp. */
      .cl-footer > div:last-child {
        display: none !important;
      }

      @keyframes konq-pulse {
        0%,
        100% {
          opacity: 1;
        }
        50% {
          opacity: 0.4;
        }
      }

      @media print {
        /* react-to-print clona a ficha num iframe: o @page define o A4 lá dentro. */
        @page {
          size: A4 portrait;
          margin: 0;
        }
        .no-print {
          display: none !important;
        }
      }
    `}
  />
);

export default GlobalStyle;
